const navs = document.querySelectorAll(".section-nav")

navs.forEach((nav) => {
  const toggle = nav.querySelector(".section-nav__toggle")
  const currentLabel = nav.querySelector(".section-nav__current")
  const links = nav.querySelectorAll(".section-nav__link")
  const sections = Array.from(links)
    .map((link) => document.getElementById(link.dataset.target))
    .filter(Boolean)

  let activeId = null

  const closeNav = () => {
    nav.classList.remove("is-expanded")
    toggle.setAttribute("aria-expanded", "false")
  }

  const openNav = () => {
    nav.classList.add("is-expanded")
    toggle.setAttribute("aria-expanded", "true")
  }

  const setActiveLink = (id) => {
    if (id === activeId) return

    activeId = id

    links.forEach((link) => {
      const isActive = link.dataset.target === id

      link.classList.toggle("is-active", isActive)

      if (isActive && currentLabel) {
        currentLabel.textContent = link.textContent
      }
    })

    history.replaceState(
      null,
      "",
      `${window.location.pathname}${window.location.search}#${id}`,
    )
  }

  toggle.addEventListener("click", () => {
    if (nav.classList.contains("is-expanded")) {
      closeNav()
    } else {
      openNav()
    }
  })

  links.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault()

      const target = document.getElementById(link.dataset.target)

      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" })
      }

      closeNav()
    })
  })

  document.addEventListener("click", (event) => {
    if (!nav.contains(event.target)) {
      closeNav()
    }
  })

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeNav()
    }
  })

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveLink(entry.target.id)
        }
      })
    },
    {
      rootMargin: "-75% 0px -20% 0px",
      threshold: 0,
    },
  )

  sections.forEach((section) => observer.observe(section))
})
